// extracted by mini-css-extract-plugin
export default {"cls1":"YapilyConnectFields-TitleRow_cls1__Mc6NK","cls2":"YapilyConnectFields-TitleRow_cls2__iUygq YapilyConnectFields-TitleRow_cls1__Mc6NK"};